import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '@mantine/core';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export const FlightSearchInput: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <TextInput
      placeholder={t('booking-flight_search_placeholder')}
      value={value}
      onChange={e => onChange(e.currentTarget.value)}
      sx={theme => ({
        padding: theme.spacing.md,
        borderBottom: '1px solid #EAEAEA',
      })}
    />
  );
};
